import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import debug from 'debug';
import {Column, Page, Row} from '../../../shared';
import PrefPanel from '../../../shared/components/preferences/PrefPanel';
import {_openModal} from '../../../shared/reducers/modals';
import StickyHeaderBar from '../components/StickyHeaderBar';

const log = debug('circleblack:preferences:panel');

const InvestorPrefPage = ({userId}) => {
  log('rendering');

  return <Page>
    <StickyHeaderBar title={'PREFERENCES'}/>
    <Column width={'100%'}>
      <Row alignItems={'top'}>
        <PrefPanel key={'prefPanel'}
                   content={{
                     panelName: 'investorGeneralWeb',
                     cat: {name: 'users', id: userId},
                   }}
                   width={'300px'}/>
        <PrefPanel key={'prefPanel'}
                   content={{
                     panelName: 'investorNotifications',
                     cat: {name: 'users', id: userId},
                   }}
                   width={'300px'}/>
      </Row>
    </Column>
  </Page>;
};

const mapStateToProps = state => ({
  userId: state.session.profile.id,
});

const mapDispatchToProps = (dispatch) => ({
  openModal: modalToOpen => dispatch(_openModal(modalToOpen)),
});

export default connect(mapStateToProps, mapDispatchToProps)(InvestorPrefPage);

InvestorPrefPage.propTypes = {
  userId: PropTypes.number.isRequired,
};
